export default "__VITE_ASSET__DXElA64a__"